import { useQuery } from "@tanstack/react-query"
import { secretStorage } from "config"
import { getUserDataFetch } from "store/middlewares/auth.crud"
import { loginHooks } from "."
import { useNavigate } from "react-router-dom"
import { app } from "router/routes"

const LoginSuccess = () => {
    const setUserData = loginHooks.useSetUserData()
    const navigate = useNavigate()

    const _ = useQuery({
        queryKey: ["user-data"],
        queryFn: async () => {
            const hash = window.location.hash; // למשל: "#token=abcd1234"
            if (hash) {
                const token = hash.split("=")[1]
                localStorage.setItem('sso_user', "true")
                const { data: user } = await getUserDataFetch(token)
                setUserData(user)
            }
            else navigate(app.login)
        }
    })

    return null
}
export default LoginSuccess